<template>
  <div id="layout-wrapper">
    <top-nav></top-nav>
    <site-header></site-header>
    <main class="content">
      <div class="layout-content">
        <router-view></router-view>
      </div>
    </main>
    <chat-genesys />
    <site-footer></site-footer>
  </div>
</template>

<script>
import TopNav from '@Common/TopNav'
import SiteHeader from '@Common/SiteHeader'
import SiteFooter from '@Common/SiteFooter'
import ChatGenesys from '@Common/ChatGenesys.vue'
import '@Styles/web-styles/css/main.css'
export default {
  created() {
    this.changeSetRouteTitle()
    this.setTagManager()
  },
  data() {
    return {}
  },
  components: {
    TopNav,
    SiteHeader,
    SiteFooter,
    ChatGenesys
  },
  methods: {
    changeSetRouteTitle() {
      let title = 'ORES - ' + this.$t('Portail Client')
      let routeTitle = this.$route.meta.pageTitle

      if (typeof routeTitle !== 'undefined') {
        title = this.$t(routeTitle) + ' | ' + title
      }

      document.title = title
    },
    setTagManager() {
      const gtmId = 'GTM-PLCN96'
      const gtmDataLayer = 'dataLayer'

      window[gtmDataLayer] = window[gtmDataLayer] || []
      const gtm = window[gtmDataLayer]
      gtm.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      })
      const parentScriptTag = document.getElementsByTagName('script')[0]
      const gtmScriptTag = document.createElement('script')
      const dl = gtmDataLayer !== 'dataLayer' ? '&l=' + gtmDataLayer : ''

      gtmScriptTag.async = true
      gtmScriptTag.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmId + dl

      parentScriptTag.parentNode.insertBefore(gtmScriptTag, parentScriptTag)
    }
  },
  watch: {
    $route: 'changeSetRouteTitle'
  }
}
</script>
